import MojitoPresentation from 'mojito/presentation';
import MojitoCore from 'mojito/core';

import {icon} from '#core/utils/style-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {generatePrimaryButton, generateSecondaryButton} from '../tiles/button/index.js';

const merge = MojitoCore.Presentation.uiStyle.merge;

const NavigationPathBuilder = MojitoPresentation.Base.Navigation.NavigationPathBuilder;

export function interfaceFactory(PALETTE) {
    const {FONT} = PALETTE;

    const CONTAINER_STYLE = {
        minHeight: '64px',
        _mobile_minHeight: 'auto',
        _mobile_alignItems: 'center',
        textTransform: 'none',
        fontStretch: 'normal',
        fontFamily: FONT.FAMILY,
        fontWeight: FONT.WEIGHT_NORMAL,
        fontSize: FONT.SIZE_XXSMALL,
        padding: '0 8px',
        _mobile_padding: '8px',
    };

    return {
        AppBanner: {
            container: {
                itemSpacing: 10,
                style: {
                    ...CONTAINER_STYLE,
                    padding: '8px 0',
                    _mobile_padding: '8px 0',
                    ...PALETTE.APP_BANNER_TEXT,
                },
            },
            closeIcon: {
                src: 'close',
                style: {
                    minHeight: 8,
                    minWidth: 8,
                    fill: PALETTE.APP_BANNER_CLOSE_ICON,
                },
            },
            linkButton: merge(generateSecondaryButton(PALETTE.APP_BANNER_BUTTON), {
                style: {
                    base: {
                        textAlign: 'center',
                        padding: '0 4px',
                    },
                },
            }),
        },
        CookieConsent: {
            button: generatePrimaryButton(PALETTE.COOKIE_CONSENT_BUTTON),
            style: {
                textArea: {
                    alignItems: 'center',
                    display: 'flex',
                    itemSpacing: '8px',
                    ...PALETTE.COOKIE_CONSENT_TEXT,
                },
            },
            policyLink: merge(generateSecondaryButton(PALETTE.COOKIE_CONSENT_POLICY_BUTTON), {
                style: {
                    base: {
                        padding: '0 8px',
                        marginLeft: '16px',
                        whiteSpace: 'nowrap',
                        _mobile_display: 'none',
                    },
                },
            }),
            container: {
                itemSpacing: '8px',
                style: {
                    ...CONTAINER_STYLE,
                    padding: '0 8px',
                    _mobile_padding: '8px',
                    ...resolveBackground(PALETTE.COOKIE_CONSENT_BG),
                },
            },
        },
        ApplicationHeader: {
            // Described in application header factory, need to keep Mojito structure
            appBannerContainer: {
                style: {
                    base: {
                        ...resolveBackground(PALETTE.APP_BANNER_BG),
                    },
                },
            },
            cookieConsentWrapper: {
                position: 'unset',
            },
        },
        SystemInitialisation: {
            timeRemaining: {
                style: {
                    fontFamily: FONT.FAMILY,
                    fontSize: FONT.SIZE_MEDIUM,
                    fontWeight: FONT.WEIGHT_NORMAL,
                    ...PALETTE.SYSTEM_INITIALIZATION_TEXT,
                },
            },
            title: {
                style: {
                    fontFamily: FONT.FAMILY,
                    fontSize: 24,
                    fontWeight: FONT.WEIGHT_NORMAL,
                    ...PALETTE.SYSTEM_INITIALIZATION_TEXT,
                },
            },
        },
        QuickStartGuideBanner: {
            container: {
                style: {
                    ...resolveBackground(PALETTE.QSG_BANNER_CONTAINER_BG),
                    boxShadow: PALETTE.QSG_BANNER_CONTAINER_SHADOW,
                },
            },
            text: {
                style: {
                    textTransform: 'none',
                    fontStretch: 'normal',
                    fontFamily: FONT.FAMILY,
                    fontWeight: FONT.WEIGHT_NORMAL,
                    fontSize: FONT.SIZE_MEDIUM,
                    ...PALETTE.QSG_BANNER_TEXT,
                },
            },
            closeButton: {
                buttonIcon: icon(PALETTE.QSG_BANNER_CLOSE_BUTTON.CLOSE_BUTTON_ICON_COLOR, 'close'),
            },
            openGuideButton: generatePrimaryButton(PALETTE.QSG_BANNER_OPEN_GUIDE_BUTTON),
            openGuideIntent: {
                type: MojitoPresentation.Base.Intent.Types.VIEW,
                data: NavigationPathBuilder.toQuickStartGuide(),
            },
        },
    };
}
